import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Avatar from '../../../base/avatar/components/Avatar';
import ContextMenu from '../../../base/ui/components/web/ContextMenu';
import ContextMenuItemGroup from '../../../base/ui/components/web/ContextMenuItemGroup';
import { setVolume } from '../../../filmstrip/actions.web';
import { showOverflowDrawer } from '../../../toolbox/functions.web';
import { hasVoiceAgentMenuItems } from '../../functions.web';
import VolumeSlider from './VolumeSlider';
/**
 * The context menu of a voice agent. An agent is a participant without a transport of its own, so neither the
 * moderation and messaging actions of a participant nor the actions of the other fake participants (shared video,
 * whiteboard) apply to it. What does apply is what this participant can do for themselves, starting with the
 * volume; a video source later changes nothing here.
 *
 * @param {IProps} props - The props of the component.
 * @returns {JSX.Element}
 */
const VoiceAgentContextMenu = ({ className, closeDrawer, drawerParticipant, offsetTarget, onEnter, onLeave, onSelect, participant, thumbnailMenu }) => {
    const dispatch = useDispatch();
    const _overflowDrawer = useSelector(showOverflowDrawer);
    const { participantsVolume } = useSelector((state) => state['features/filmstrip']);
    const _volume = participantsVolume[participant.id] ?? 1;
    const clickHandler = useCallback(() => onSelect(true), [onSelect]);
    const _onVolumeChange = useCallback((value) => {
        dispatch(setVolume(participant.id, value));
    }, [participant.id, dispatch]);
    const hasItems = useSelector((state) => hasVoiceAgentMenuItems(state, Boolean(thumbnailMenu)));
    const showVolumeSlider = hasItems && typeof _volume === 'number' && !isNaN(_volume);
    return (React.createElement(ContextMenu, { activateFocusTrap: !thumbnailMenu, className: className, entity: participant, hidden: thumbnailMenu ? false : undefined, inDrawer: thumbnailMenu && _overflowDrawer, isDrawerOpen: Boolean(drawerParticipant), offsetTarget: offsetTarget, onClick: onSelect, onClickOutside: thumbnailMenu ? undefined : clickHandler, onDrawerClose: thumbnailMenu ? onSelect : closeDrawer, onMouseEnter: onEnter, onMouseLeave: onLeave },
        !thumbnailMenu && _overflowDrawer && drawerParticipant && React.createElement(ContextMenuItemGroup, { actions: [{
                    accessibilityLabel: drawerParticipant.displayName,
                    customIcon: React.createElement(Avatar, { participantId: drawerParticipant.participantID, size: 20 }),
                    text: drawerParticipant.displayName
                }] }),
        showVolumeSlider && (React.createElement(ContextMenuItemGroup, null,
            React.createElement(VolumeSlider, { initialValue: _volume, key: 'volume-slider', onChange: _onVolumeChange })))));
};
export default VoiceAgentContextMenu;
